export var AdSetupType;
(function (AdSetupType) {
    AdSetupType["CSAI"] = "csai";
    AdSetupType["SSAI"] = "ssai";
})(AdSetupType || (AdSetupType = {}));
